// extracted by mini-css-extract-plugin
export var brand = "_79-9";
export var compact = "_79-6";
export var extraSmall = "_79-7";
export var icon = "_79-0";
export var large = "_79-4";
export var light = "_79-1";
export var medium = "_79-5";
export var outline = "_79-b";
export var primaryDark = "_79-a";
export var primaryLight = "_79-8";
export var primaryModern = "_79-c";
export var success = "_79-2";
export var successSolid = "_79-3";